module.exports = __webpack_public_path__ + "img/icon_yinshuiji_01.7812d1e4.png";